export class FetcherConnectionLostError extends Error {
  constructor() {
    const errorMessage = `Client lost internet connection`;
    super(errorMessage);

    this.name = "FetcherConnectionLostError";
    this.message = errorMessage;
  }
}
